import React from "react";
import styles from './settings_section.module.css';

export default function SettingsSection({title, description, children}) {
    let leftChildren = [];
    let rightChildren = [];

    React.Children.forEach(children, (child) => {
        if (child.props.side === "left") {
            leftChildren.push(child);
        } else if (child.props.side === "right") {
            rightChildren.push(child);
        }
    });

    return (
        <div className={`${styles.container} mt-2`}>
            <div className={'d-flex justify-content-between flex-wrap'}>
                <div style={{textAlign: "left"}} className={styles.flexBasisController}>
                    <div className={`${styles.title} mb-1`}>{title}</div>
                    <div className={styles.desc}>{description}</div>
                    <div>{leftChildren.map((child, index) => child)}</div>
                </div>
                <div style={{textAlign: "left"}} className={styles.flexBasisController}>{rightChildren.map((child, index) => child)}</div>
            </div>
        </div>
    );
}